<ul class="select-box" [ngStyle]="{'top': top, 'bottom': bottom}" [@displaySelectBox]="state" (@displaySelectBox.done)="animationDone()">
  @for (item of items; track item) {
    <li [ngClass]="{'active': item === selectedItem}" (click)="selectItem(item)">
      {{item}}
    </li>
  }
</ul>